import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-order",
  "use": "icon-order-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-order\"><g fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\"><rect width=\"14\" height=\"17\" x=\"5\" y=\"4\" rx=\"2\" /><path stroke-linecap=\"round\" d=\"M9 9h6m-6 4h6m-6 4h4\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol